/* This file is autogenerated, see readme.md for instructions */
import TabletPortraitSvgIcon from '@bloomreach/banana-theme/icons/tablet-portrait.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const TabletPortraitIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <TabletPortraitSvgIcon />
    </Icon>
  );
});

TabletPortraitIcon.displayName = 'TabletPortraitIcon';

export default TabletPortraitIcon;
